import { createContext, useCallback, useContext, useEffect } from "react";
import { useAccountContext } from "../AccountProvider/AccountProvider";

const FreshchatContext = createContext();

export const FreshchatProvider = ({ children }) => {
  const { accountInfo } = useAccountContext();

  const updateTrackingCodeField = useCallback(
    (value) => {
      if (!accountInfo.email || !accountInfo.contactName) {
        return;
      }
      try {
        window.fcWidget.user.setProperties({
          email: accountInfo.email,
          firstName: accountInfo.contactName,
          zipcode: value,
        });
      } catch (e) {
        console.warn("Unable to set zipcode field", e);
      }
    },
    [accountInfo.email, accountInfo.contactName],
  );

  const resetTrackingCodeField = useCallback(
    (value) => {
      if (!accountInfo.email || !accountInfo.contactName) {
        return;
      }
      try {
        window.fcWidget.user.setProperties({
          email: accountInfo.email,
          firstName: accountInfo.contactName,
          zipcode: "undefined",
        });
      } catch (e) {
        console.warn("Unable to reset zipcode field", e);
      }
    },
    [accountInfo.email, accountInfo.contactName],
  );

  useEffect(() => {
    if (!accountInfo.email || !accountInfo.contactName) {
      window.fcWidget.user.setProperties({
        email: "",
        firstName: "",
        zipcode: "undefined",
      });
      return;
    }
    try {
      window.fcWidget.user.setProperties({
        email: accountInfo.email,
        firstName: accountInfo.contactName,
        zipcode: "undefined",
      });
    } catch (e) {
      console.warn("Unable to set user info", e);
    }
  }, [accountInfo.email, accountInfo.contactName]);

  return (
    <FreshchatContext.Provider value={{ updateTrackingCodeField, resetTrackingCodeField }}>
      {children}
    </FreshchatContext.Provider>
  );
};

/**
 * Custom hook to consume freshchat context.
 * @throws Will throw an error if used outside the FreshchatProvider component.
 */
export const useFreshchatContext = () => {
  const context = useContext(FreshchatContext);
  if (!context) {
    throw new Error("useFreshchatContext must be used within an FreshchatProvider");
  }
  return context;
};
